<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-bodymatter element-container-single element-type-chapter element-with-heading" id="chapter-2">
<div class="heading heading-with-title heading-without-image" id="chapter-2-heading">
<div class="heading-contents">
<div class="title-subtitle-block title-block-title-is-element-number">
<div class="element-number-block">
</div>
<div class="title-block">
<h1 class="title">2</h1>
</div>
</div>
</div>
</div>
<div class="text" id="chapter-2-text">
<p class="first first-in-chapter first-full-width"><span class="drop-cap">D</span>CI Alex Fleming watched from an upstairs window to see the chief constable’s car pulling into the car park. Superintendent Liz Temple, dressed in black suit and white shirt, had gone down to meet him. She strode across the tarmac as Matthew Upson climbed out of the rear passenger door.</p>
<p class="subsq">‘He’s here,’ Fleming said, coming out of his office to the open-plan area where DS Logan and DC Anderson sat.</p>
<p class="subsq">‘Invited to join them?’ Logan asked Fleming.</p>
<p class="subsq">‘Not sure why, but yes. The super’s going to call me.’</p>
<p class="subsq">‘Feel a bit sorry for him,’ Logan said. ‘They say the police and crime commissioner had it in for him from the day he was elected.’</p>
<p class="subsq">Fleming shrugged. ‘Too many unsolved murder cases, a few corrupt detectives, and a disgraced assistant chief constable all on Daubney’s watch didn’t help much.’</p>
<p class="subsq">‘Tough at the top, eh?’</p>
<p class="subsq">‘Of course, you wouldn’t know about that, Sarge,’ Anderson quipped.</p>
<p class="subsq">‘We only arrived in the office an hour ago and Naomi’s already flinging insults at me,’ Logan complained.</p>
<p class="subsq">‘Only joking, Sarge. You’re far too sensitive.’</p>
<p class="subsq">Logan screwed up a loose piece of paper and threw it across the adjoining desks at Anderson.</p>
<p class="subsq">‘Upson might wander round here after I’ve seen him, so be on your best behaviour. No fooling about.’</p>
<p class="subsq">‘When do we ever?’ Logan asked with a smile.</p>
<p class="subsq">‘<i>We</i> don’t,’ Anderson said. ‘It’s just you.’</p>
<p class="subsq">Fleming raised his eyes to the ceiling. ‘All the same, Upson may be retiring but we still want to give a good impression.’</p>
<p class="subsq">‘As always,’ Logan and Anderson said in unison.</p>
<p class="subsq">Fleming laughed. ‘Anyone for a coffee? Vending machine only. Round’s on me.’</p>
<p class="subsq">‘Usual for me,’ Logan said.</p>
<p class="subsq">‘Same,’ came from Anderson. ‘Thanks, sir.’</p>
<p class="subsq">Fleming set off to the far end of the open-plan area to get the coffees.</p>
<p class="subsq">When he returned, Logan was putting his phone down. ‘Going to miss yours,’ he said. ‘Super’s summonsed you.’</p>
<p class="subsq">Fleming put the three coffees down on Anderson’s desk. ‘Looks like one of you gets two cups.’</p>
<p class="subsq">‘That’ll be me,’ Logan said. ‘Seniority,’ he added with a smile.</p>
<p class="subsq">Fleming wagged a finger. ‘Best behaviour, remember.’ He laughed as he headed towards Temple’s office.</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">Fleming knocked on Temple’s door and heard her call him in. She was sitting at the small coffee table she used for informal meetings. Upson sat opposite her. ‘Pull up a chair,’ Temple said.</p>
<p class="subsq">Upson rose from his chair and offered a hand. ‘Good to see you, Fleming. I’ve heard good things about you. We need more like you on the force.’</p>
<p class="subsq">‘Thank you, sir.’</p>
<p class="subsq">They took their seats as Temple poured coffee.</p>
<p class="subsq">Upson looked at Fleming. ‘I wanted to see you before I left. Wanted to thank you for the excellent work you’re doing.’ Upson coughed. ‘Despite some rather awkward internal politics getting in the way at times.’</p>
<p class="subsq">Fleming knew what he was talking about and wasn’t sure how to respond. There had been a few hiccups during his first two cases since joining the major crime unit. ‘I try never to let anything get in the way of a murder investigation.’</p>
<p class="subsq">‘Well… just so you know, I appreciate what you’re doing.’</p>
<p class="subsq">‘Thanks. Looking forward to retirement, sir?’ As soon as he said it, Fleming realised it wasn’t the best thing to say.</p>
<p class="subsq">Upson laughed. ‘We all know it wasn’t a matter of choice. Daubney more or less invited me to resign.’ He tapped his hand on Fleming’s arm. ‘Remember that when the next police and crime commissioner elections are due.’</p>
<p class="subsq">Fleming smiled. ‘I will.’</p>
<p class="subsq">‘Matthew was telling me he and his wife are planning to move to Darmont,’ Temple said.</p>
<p class="subsq">Fleming raised an eyebrow. ‘Oh?’</p>
<p class="subsq">Upson stretched his legs. ‘Yes, my daughter and the grandchildren live in London and Darmont has a station with a direct line. We can get there in less than an hour. It’s also a picture-postcard village. Old church, pond, local butcher… and two good pubs.’</p>
<p class="subsq">‘Sounds good. Have you found somewhere yet?’ Fleming asked.</p>
<p class="subsq">‘We’ve put an offer in which we’re confident they’ll accept. House prices there have fallen a bit.’</p>
<p class="subsq">‘Bit against the national trend. Any particular reason?’</p>
<p class="subsq">‘Property developer, Paul Canning, has put in a planning application. It’s for a major housing and shopping development on the outskirts of the village.’</p>
<p class="subsq">‘It’s caused a bit of a stir by all accounts,’ Temple said. ‘It’s on a greenfield site. The parish council has objected to it on the basis it flies in the face of the local neighbourhood plan. The district council seem to be in favour because it’s in line with the county local plan for development. Things are getting a bit heated. Protests, death threats, and allegations of bribery and corruption.’</p>
<p class="subsq">Upson sighed. ‘Yes, all a bit unfortunate. Especially for local people trying to sell property.’</p>
<p class="subsq">‘Those on the edge of the site presumably,’ Fleming guessed.</p>
<p class="subsq">‘Yes. The house we’ve made an offer on backs onto it. I do feel sorry for the people selling, but we can’t offer more than the current market value.’</p>
<p class="subsq">‘And, if you ever decided to move again, you would have the same problem over the value of the house,’ Fleming said.</p>
<p class="subsq">‘Exactly.’</p>
<p class="subsq">‘More coffee?’ Temple asked.</p>
<p class="subsq">Upson rose to his feet. ‘No, thanks. Should get back to Kidlington. One or two people there I need to say cheerio to.’ He shook Temple’s hand before turning to Fleming. ‘Carry on the good work, young man.’ He grasped Fleming’s hand with a firm grip.</p>
<p class="subsq">Fleming took his leave, amused that Upson saw him as a young man. He’d turned thirty-nine a few months ago.</p>
<div class="ornamental-break">
<div class="ornamental-break-block ornamental-break-aspect-wide">
<div class="ornamental-break-size-container ornamental-break-width-188">
<img alt="" class="ornamental-break-image" src="images/break-section-side-screen.png"/>
</div>
</div>
</div>
<p class="first first-in-section first-full-width">‘We were all ready to be on our best behaviour,’ Logan said, ‘but he didn’t come to see us.’</p>
<p class="subsq">‘Sorry, Harry. He had to go… people to see.’</p>
<p class="subsq">‘More important than us,’ Logan mumbled.</p>
<p class="subsq">Anderson laughed. ‘A few minutes ago, you were saying you hoped he wouldn’t come through. Can’t do with all the forelock tugging, you said.’</p>
<p class="subsq">Logan offered a shrug and grinned.</p>
<p class="subsq">‘He’s moving to Darmont,’ Fleming said. ‘The super reckons there’s trouble brewing there over a planning application.’</p>
<p class="subsq">‘Yes, I heard,’ Anderson said. ‘You never know, our next case may come from there.’</p>
<p class="subsq">‘Don’t joke about things like that, Naomi,’ Fleming said. ‘Upson’s going to live there.’</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter-002.vue?3bb16053